export default [
    { name: "English", code: "en" },
    { name: "Indonesia", code: "id" }
];
